export const MAX_INLINE_CATEGORIES = 12;
